import { batch } from "react-redux";
import {
  updateAuthToken,
  updateCurrentPatientId,
  updatePatientList,
  updateSignedInState,
  updateSSOToken,
  updateTokenRecievedFetchPatients,
  updateTokenRefresh,
  updateUserCorporateTag,
  updateUserType,
} from "@/redux/slice/auth/slice";
import authSignOut from "@/redux/slice/auth/thunks/authSignOut";

import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import routes from "@/helpers/router";
import { removeCookie } from "@/helpers/cookies";
import { LOGIN_COOKIE_NAME } from "@/libs/constants/auth";

export default async function performSignOutUpdates({ redirectUrl = routes.home, dispatch }) {
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("mobile_num");
  localStorage.removeItem("currentUser");
  localStorage.removeItem("pharmaPincode");
  localStorage.removeItem("pharmaAddressDetails");
  localStorage.removeItem("CIRCLEPlan");
  let t = sessionStorage.getItem("t");
  let utm_source = sessionStorage.getItem("utm_source");
  sessionStorage.clear();
  let params = new URLSearchParams(window.location.search);

  if (params.get("utm_source") && params.get("t")) {
    sessionStorage.setItem("t", t);
    sessionStorage.setItem("utm_source", utm_source);
  }

  removeCookie(LOGIN_COOKIE_NAME);

  batch(() => {
    dispatch?.(updateAuthToken(""));
    dispatch?.(updateSSOToken(""));
    dispatch?.(updateTokenRefresh(false));
    dispatch?.(updateSignedInState(SignedinState.SIGNEDOUT));
    dispatch?.(updateCurrentPatientId(""));
    dispatch?.(updatePatientList([]));
    dispatch?.(updateTokenRecievedFetchPatients(false));
    dispatch?.(updateUserType(null));
    dispatch?.(updateUserCorporateTag(""));
    dispatch?.(authSignOut({ redirectUrl }));
  });
}
